import { useOutletContext } from "react-router-dom";

const Home = () => {
    const [userId] = useOutletContext();

    return userId ? (<div>
        <h1>Home</h1>
        <p>You are logged in</p>
    </div>) : (<div>
        <h1>Home</h1>
        <a className="button google" href="/login/federated/google">
            <i className="fab fa-google"></i> Sign in with Google
        </a>
    </div>);
  };
  
  export default Home;